import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Enquiry } from "@/models/enquiry/Enquiry";
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators, AbstractControl, } from "@angular/forms";
import { AppService } from "@services/app.service";
import { ToastrService } from "ngx-toastr";
import { BillingDetails, BillItemDetails } from "@/models/billing/BillingDetails";
import * as CryptoJS from 'crypto-js';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { ProductVariantDetails } from '@/models/product-variant-details/product-variant-details';
import { Address } from '@/models/address/Address';
import { CategoryDetails } from '@/models/category-details/category-details';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ShopAddress } from '@/models/billing/ShopAddressDetails';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrl: './invoice.component.scss'
})
export class InvoiceComponent implements OnInit, OnDestroy {
  customerEnquiry: any | undefined;
  invoiceDetails: BillingDetails | undefined;
  isOnlineBill: boolean = true;
  private secretKey = "#EVOL-&$%$DF%SION*^%#^*F&%^DFSEYUJ";
  destroy$: Subject<boolean> = new Subject<boolean>();
  resellerList: Address[] = [];
  isShowExchange: boolean = false;
  isShowInvoiceBill: boolean = false;
  billId: number = 0;
  isUpdate: boolean = false;
  currentDate: string = "";
  barcodeSubject = new Subject<{ index: number, value: string }>();
  //Indian State List
  states: string[] = [
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Ladakh',
    'Lakshadweep',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Puducherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];

  paymentOptions = [
    { value: 'ONLINE', label: 'Online' },
    { value: 'CASH', label: 'Cash' },
    { value: 'CREDIT', label: 'Credit' },
  ]
  options: { value: string; label: string }[] = [];

  productVariants: { [index: number]: ProductVariantDetails[] } = {};
  showResellerAddress: boolean = false;
  @ViewChild('scannerInput') scannerInput!: ElementRef<HTMLInputElement>;
  scannedBarcodes = new Set<string>();
  shippingDetails: any[] = [];
  selectedShipping: any = null;
  shipping = 0;
  selectedState: string = 'Tamil Nadu';
  categoryDetails: CategoryDetails[] = [];
  currentBillingDetails: any;
  codAmount = 0;
  productTotal = 0;
  discountTotal = 0;
  grandTotal = 0;
  originalDueAmount: number = 0;
  tamilNaduStates = new Set(['tamil nadu', 'puducherry']);
  southIndiaStates = new Set(['kerala', 'karnataka', 'andhra pradesh', 'telangana']);
  previousPaidAmount: number = 0;
  manualDiscount: number = 0;
  getAddressDetails: ShopAddress[] = [];

  customerDetails: any = null;
  customerAddresses: any[] = [];
  selectedCustomerAddress: any = null;
  customerWalletBalance: number = 0;
  customerSearchLoading: boolean = false;
  walletDebitAmount: number = 0;
  walletCreditAmount: number = 0;
  isReduceFromWallet: boolean = false;
  isDraft: boolean = false;
  isSubmitting: boolean = false;
  // Original values loaded while editing
  originalWalletDebitAmount: number = 0;
  originalWalletCreditAmount: number = 0;
  originalInvoiceTotal: number = 0;
  originalPaidAmount: number = 0;

  constructor(private router: Router, private spinner: NgxSpinnerService, private appService: AppService, private toastr: ToastrService
  ) {
    const today = new Date();
    this.currentDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')
      }-${today.getDate().toString().padStart(2, '0')}`
  }

  invoiceFormGroup = new UntypedFormGroup({
    billId: new UntypedFormControl(0),
    customerName: new UntypedFormControl("", [Validators.required, Validators.nullValidator]),
    phoneNumber: new UntypedFormControl("", [Validators.required, Validators.nullValidator,
    Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10),
    Validators.maxLength(10)]),
    doorNo: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    city: new UntypedFormControl(''),
    state: new UntypedFormControl('Tamil Nadu'),
    pincode: new UntypedFormControl(0),
    subTotal: new UntypedFormControl(0),
    discount: new UntypedFormControl(0),
    totalAmount: new UntypedFormControl(0),
    invoiceDate: new UntypedFormControl(""),
    billingType: new UntypedFormControl(''),
    shopId: new UntypedFormControl(0),
    billingStatus: new UntypedFormControl(''),
    paymentMethod: new UntypedFormControl('',),
    createdAt: new UntypedFormControl(0),
    createdBy: new UntypedFormControl(0),
    updatedAt: new UntypedFormControl(0),
    updatedBy: new UntypedFormControl(0),
    userRegId: new UntypedFormControl(0),
    orderVia: new UntypedFormControl(''),
    invoiceNumber: new UntypedFormControl(''),
    exchangeStatus: new UntypedFormControl(''),
    exchangeAmount: new UntypedFormControl(''),
    note: new UntypedFormControl(''),
    products: new UntypedFormArray([]),
    resellerName: new UntypedFormControl(''),
    resellerPhone: new UntypedFormControl("", [Validators.required, Validators.nullValidator,
    Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10),
    Validators.maxLength(10)]),
    gstNumber: new UntypedFormControl(''),
    transactionRefId: new UntypedFormControl(0),
    weight: new UntypedFormControl(0),
    trackingNumber: new UntypedFormControl(''),
    paidAmount: new UntypedFormControl(0),
    dueAmount: new UntypedFormControl(0),
    shippingAmount: new UntypedFormControl(0),
    manualDiscountAmount: new UntypedFormControl(0),
    availableStock: new UntypedFormControl(0),
    billingItemId: new UntypedFormControl(0),
    shopAddressId: new UntypedFormControl(0),
    addressId: new UntypedFormControl(0),
    userAddress: new UntypedFormControl(''),
    userAddresses: new UntypedFormControl([]),
    bulkAddress: new UntypedFormControl(''),
    walletDebitAmount: new UntypedFormControl(0),
    walletCreditAmount: new UntypedFormControl(0),
    isReduceFromWallet: new UntypedFormControl(false)
  })


  ngAfterViewInit() {
    // Focus scanner input when component loads
    setTimeout(() => {
      this.scannerInput.nativeElement.focus();
    }, 200);
  }

  ngOnInit() {
    const billId = String(localStorage.getItem("billId"))
    this.billId = Number(atob(billId)) || 0;
    if (this.billId == 0) {
      this.customerEnquiry = JSON.parse(localStorage.getItem('lfCustomerDetail') || '[]');
      this.invoiceFormGroup.controls['state']?.setValue('Tamil Nadu')
      const isEmpty = Object.keys(this.customerEnquiry).length === 0;
      if (Object.keys(this.customerEnquiry).length === 0 == false) {
        this.getFormGroup(this.customerEnquiry);
      }
      this.isShowInvoiceBill = true;
      // Set default value for billType
      this.invoiceFormGroup.get('billingType')?.setValue(isEmpty ? 'ONLINE' : 'SHOP');
      if (this.invoiceFormGroup.get('billingType')?.value === 'ONLINE') {
        this.isOnlineBill = false;
        this.options = [
          { value: 'Instagram', label: 'Instagram' },
          { value: 'Whatsapp', label: 'Whatsapp' },
          { value: 'Facebook', label: 'Facebook' },
          { value: 'Resale', label: 'Resale' }
        ];
        this.invoiceFormGroup.controls['paymentMethod'].setValue("ONLINE");
      } else {
        this.isOnlineBill = true;
        this.options = [
          { value: 'Website', label: 'Website' }
        ];
      }
      this.invoiceFormGroup.get('billingStatus')?.setValue('PAID');
      this.productVariants[0] = this.customerEnquiry?.productDetails?.productVariantDetails
        ?.filter((variant: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.size === variant.size)
        );
    } else if (this.billId != 0) {
      this.isUpdate = true;
      this.getByBillIdDetails();
    }
    this.invoiceFormGroup.controls['invoiceDate'].setValue(this.currentDate);
    this.invoiceFormGroup.get('manualDiscountAmount')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {

        let val = Number(value || 0);

        const max = this.getMaxManualDiscount();

        if (val < 0) val = 0;
        if (val > max) val = max;

        this.manualDiscount = val;

        this.invoiceFormGroup.patchValue({
          manualDiscountAmount: val
        }, { emitEvent: false });

        this.updateTotalAmount();
      });

    this.barcodeSubject
      .pipe(
        debounceTime(400), // wait user typing
        distinctUntilChanged((a, b) => a.value === b.value)
      )
      .subscribe(({ index, value }) => {
        this.fetchBarcode(index, value);
      });
    this.getAllShopAddressDetails();
  }

  get isShop(): boolean {
    return this.invoiceFormGroup.get('billingType')?.value == 'ONLINE';
  }

  selectDate(event: any) {
    const value = event.target.value;
  }

  getByBillIdDetails(): void {

  this.spinner.show();


  this.appService
    .getBillDetailById(this.billId)
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe({

      next: (response: BillingDetails) => {

        this.spinner.hide();

        // ====================================================
        // SET UPDATE MODE
        // ====================================================

        this.isUpdate = true;


        // ====================================================
        // KEEP ORIGINAL BILL
        // ====================================================

        this.currentBillingDetails =
          response;


        // ====================================================
        // FIRST LOAD ORIGINAL WALLET VALUES
        // ====================================================

        this.loadOriginalWalletValues(
          response
        );


        // ====================================================
        // PATCH EXISTING BILL
        // ====================================================

        this.invoiceFormGroup.patchValue(
          response,
          {
            emitEvent: false
          }
        );


        // ====================================================
        // PHONE NUMBER FROM EXISTING BILL
        // ====================================================

        const phoneNumber =
          String(
            response?.phoneNumber || ''
          )
            .replace(/\D/g, '')
            .substring(0, 10);

        // ====================================================
        // GET LATEST WALLET USING PHONE NUMBER
        // ====================================================

        if (
          phoneNumber.length === 10 &&
          /^[6-9]\d{9}$/.test(phoneNumber)
        ) {

          this.getCustomerByPhone(
            phoneNumber,
            true
          );

        } else {
          this.customerWalletBalance = 0;
        }


        // ====================================================
        // MANUAL DISCOUNT
        // ====================================================

        const manualDiscount =
          Number(
            response.manualDiscountAmount || 0
          );


        this.manualDiscount =
          manualDiscount;


        this.previousPaidAmount =
          Number(
            response.paidAmount || 0
          );


        this.invoiceFormGroup.patchValue({

          ...response,

          manualDiscountAmount:
            manualDiscount

        }, {
          emitEvent: false
        });


        // ====================================================
        // SHIPPING
        // ====================================================

        this.selectedShipping = {

          shippingPartner:
            response.shippingPartner,

          amount:
            Number(
              response.shippingAmount || 0
            )

        };


        this.shipping =
          Number(
            response.shippingAmount || 0
          );


        this.isShowInvoiceBill = true;


        // ====================================================
        // BILLING TYPE
        // ====================================================

        if (
          this.invoiceFormGroup
            .get('billingType')
            ?.value === 'ONLINE'
        ) {

          this.isOnlineBill = false;


          this.options = [

            {
              value: 'Instagram',
              label: 'Instagram'
            },

            {
              value: 'Whatsapp',
              label: 'Whatsapp'
            },

            {
              value: 'Facebook',
              label: 'Facebook'
            },

            {
              value: 'Resale',
              label: 'Resale'
            }

          ];

        } else {

          this.isOnlineBill = true;


          this.options = [

            {
              value: 'Website',
              label: 'Website'
            }

          ];
        }

        // Restore Reseller Details visibility during Edit.
const orderVia = String(response?.orderVia || '').trim();

this.showResellerAddress =
  orderVia.toLowerCase() === 'resale';

// Restore saved reseller values.
this.invoiceFormGroup.patchValue({
  orderVia: orderVia,
  resellerName: response?.resellerName || '',
  resellerPhone: response?.resellerPhone || '',
  gstNumber: response?.gstNumber || '',
  // resellerAddressId: response?.resellerAddressId
  //   ? String(response.resellerAddressId)
  //   : ''
});


        // ====================================================
        // LOAD PRODUCTS
        // ====================================================

        const productsArray =
          this.invoiceFormGroup
            .get('products') as UntypedFormArray;


        productsArray.clear();


        this.productVariants = {};

        this.categoryDetails = [];


        if (
          Array.isArray(response.products)
        ) {

          let completed = 0;

          const totalProducts =
            response.products.length;


          const finishLoading = () => {

            completed++;


            if (
              completed === totalProducts
            ) {

              setTimeout(() => {

                this.recalculateCart();


                if (
                  this.invoiceFormGroup
                    .get('billingType')
                    ?.value === 'ONLINE'
                ) {

                  const state =
                    this.invoiceFormGroup
                      .get('state')
                      ?.value;


                  this.calculateItemWiseShipping(
                    state
                  );
                }


                // =========================================
                // WALLET RECALCULATION
                // =========================================

                // getCustomerByPhone() will already have
                // fetched the latest wallet.
                //
                // This recalculates once products/total
                // are loaded.
                this.updateTotalAmount();

                this.updateWalletCalculation();

              }, 200);
            }
          };


          response.products.forEach(
            (product: any, index: number) => {

              this.addEmptyItem();


              const row = this.products.at(index) as UntypedFormGroup;

              row.patchValue({

                billingItemId:
                  product.billingItemId

              }, {
                emitEvent: false
              });


              const hasVariant =
                product.productVariantId &&
                product.productVariantId !== 0;


              const hasBarcode =
                product.productCode &&
                product.productCode.trim() !== '';


              // ==========================================
              // ONLINE PRODUCT
              // ==========================================

              if (hasVariant) {

                this.appService
                  .getByBarcodeDetails(
                    product.productCode
                  )
                  .pipe(
                    takeUntil(this.destroy$)
                  )
                  .subscribe({

                    next: (res: any) => {

                      const variants =
                        res?.productVariantDetails ||
                        [];

                      const discounts =
                        res?.discounts ||
                        [];


                      this.productVariants[index] =
                        variants;


                      const selectedVariant =
                        variants.find(
                          (v: any) =>
                            v.productVariantId ===
                            product.productVariantId
                        );


                      if (!selectedVariant) {

                        finishLoading();

                        return;
                      }


                      this.categoryDetailsGetById(
                        selectedVariant.categoryId
                      );


                      row.patchValue({

                        billingItemId:
                          product.billingItemId,

                        productId:
                          selectedVariant.productId,

                        productVariantId:
                          selectedVariant.productVariantId,

                        productName:
                          selectedVariant.productName,

                        barcodeNumber:
                          product.productCode,

                        productCode:
                          product.productCode,

                        size:
                          selectedVariant.size,

                        quantity:
                          product.quantity,

                        unitPrice:
                          product.unitPrice,

                        totalPrice:
                          product.quantity *
                          product.unitPrice,

                        categoryId:
                          selectedVariant.categoryId,

                        discounts:
                          discounts,

                        availableStock:
                          this.getBaseStock(
                            selectedVariant
                          ),

                        oldQuantity:
                          product.quantity

                      }, {
                        emitEvent: false
                      });


                      finishLoading();
                    },

                    error: () => {

                      finishLoading();
                    }

                  });


                return;
              }


              // ==========================================
              // SHOP PRODUCT
              // ==========================================

              if (
                !hasVariant &&
                hasBarcode
              ) {

                row.patchValue({

                  billingItemId:
                    product.billingItemId,

                  productId: 0,

                  productVariantId: 0,

                  productName:
                    product.productName,

                  barcodeNumber:
                    product.productCode,

                  productCode:
                    product.productCode,

                  size:
                    product.size,

                  quantity:
                    product.quantity,

                  unitPrice:
                    product.unitPrice,

                  totalPrice:
                    product.quantity *
                    product.unitPrice,

                  availableStock:
                    999999,

                  oldQuantity:
                    0

                }, {
                  emitEvent: false
                });


                finishLoading();

                return;
              }


              // ==========================================
              // MANUAL PRODUCT
              // ==========================================

              row.patchValue({

                billingItemId:
                  product.billingItemId,

                productId: 0,

                productVariantId: 0,

                productName:
                  product.productName,

                size:
                  product.size,

                quantity:
                  product.quantity,

                unitPrice:
                  product.unitPrice,

                totalPrice:
                  product.quantity *
                  product.unitPrice,

                barcodeNumber:
                  '',

                productCode:
                  '',

                availableStock:
                  999999,

                oldQuantity:
                  0

              }, {
                emitEvent: false
              });


              finishLoading();

            }
          );
        }


        // ====================================================
        // FINAL RECALCULATION
        // ====================================================

        setTimeout(() => {

          this.recalculateCart();

          this.updateTotalAmount();

          this.updateWalletCalculation();

          const state =
            this.invoiceFormGroup
              .get('state')
              ?.value;


          if (
            this.invoiceFormGroup
              .value.billingType === 'ONLINE'
          ) {

            this.calculateItemWiseShipping(
              state
            );
          }

        }, 800);

      },

      error: (error: any) => {

        this.spinner.hide();

        this.toastr.error(
          error?.error?.message ||
          'Failed to load invoice'
        );
      }

    });
}
  

  onSelectBillType() {

    const billingType = this.invoiceFormGroup.get('billingType')?.value;

    // reset flags
    this.isOnlineBill = billingType !== 'SHOP';
    this.showResellerAddress = false;
    this.isShowInvoiceBill = true;

    // IMPORTANT: prevent duplicate subscriptions
    this.invoiceFormGroup.get('orderVia')?.reset('', { emitEvent: false });

    if (billingType === 'ONLINE') {
      this.isOnlineBill = false;
      this.invoiceFormGroup.controls['paymentMethod'].setValue("ONLINE")
      this.options = [
        { value: 'Instagram', label: 'Instagram' },
        { value: 'Whatsapp', label: 'Whatsapp' },
        { value: 'Facebook', label: 'Facebook' },
        { value: 'Resale', label: 'Resale' }
      ];

      // subscribe ONCE safely
      this.invoiceFormGroup.get('orderVia')?.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          this.showResellerAddress = value === 'Resale';
        });

      // remove manual items only for ONLINE
      this.removeManualItems();

      // recalculate shipping for ONLINE
      setTimeout(() => {
        const state = this.invoiceFormGroup.get('state')?.value;
        this.calculateItemWiseShipping(state);
      });

    } else if (billingType === 'SHOP') {

      this.isOnlineBill = true;
      this.invoiceFormGroup.controls['paymentMethod'].setValue("CASE")
      this.options = [
        { value: 'Website', label: 'Website' }
      ];

      this.showResellerAddress = false;

      // CLEAR ONLINE-ONLY DATA
      this.shipping = 0;
      this.selectedShipping = null;
      this.shippingDetails = [];

      // reset totals safely
      this.updateTotalAmount();
    }
  }

  onSelectReseller() {
    if (this.invoiceFormGroup.get('orderVia')?.value == 'Resale') {
      this.showResellerAddress = true;
    } else {
      this.showResellerAddress = false;
    }
  }

  removeManualItems() {
    const productsArray = this.products;

    for (let i = productsArray.length - 1; i >= 0; i--) {
      const product = productsArray.at(i);
      if (product.get('productId')?.value == 0) {
        productsArray.removeAt(i);
      }
    }

    this.updateSubTotal();
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  getFormGroup(enquiry: Enquiry) {
    this.getAllResellers();
    this.invoiceFormGroup.patchValue(enquiry)
    this.addItem(enquiry.productDetails);
    this.invoiceFormGroup.get('discount')?.valueChanges.subscribe(() => this.updateTotalAmount());
    this.isShowInvoiceBill = true;
  }

  //get shop address details
  getAllShopAddressDetails() {
    this.appService.getAllShopAddressDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.getAddressDetails = data;
      }, (error: any) => {
        this.toastr.error(error.message || "Something Went Wrong,Please Try again....")
      })
  }

  getWalletByPhoneNumber(phoneNumber: string): void {

    const phone =
      String(phoneNumber || '').trim();

    if (!phone || !/^[6-9]\d{9}$/.test(phone)) {
      return;
    }

    this.spinner.show();

    this.appService
      .getUserByPhoneNumber(phone)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({

        next: (response: any) => {

          this.spinner.hide();

          const user =
            response?.data ||
            response;

          // ====================================================
          // GET WALLET BALANCE
          // ====================================================

          this.customerWalletBalance =
            Number(
              user?.walletBalance || 0
            );

          // ====================================================
          // SET WALLET BALANCE IN FORM IF YOU HAVE THE FIELD
          // ====================================================

          this.invoiceFormGroup.patchValue({

            walletBalance:
              this.customerWalletBalance

          }, {
            emitEvent: false
          });


          // ====================================================
          // AFTER WALLET IS RECEIVED
          // RECALCULATE WALLET AMOUNT
          // ====================================================

          this.updateWalletCalculation();

        },

        error: (error: any) => {

          this.spinner.hide();

          this.customerWalletBalance = 0;

          this.walletDebitAmount = 0;

          this.walletCreditAmount = 0;

          this.invoiceFormGroup.patchValue({

            walletBalance: 0,

            walletDebitAmount: 0,

            walletCreditAmount: 0

          }, {
            emitEvent: false
          });
        }

      });
  }

  // ============================================================
  // CUSTOMER PHONE INPUT
  // API CALL ONLY AFTER EXACTLY 10 DIGITS
  // ============================================================

  onCustomerPhoneInput(event: any): void {

  let phone = String(event?.target?.value || '');

  phone = phone.replace(/\D/g, '');
  phone = phone.substring(0, 10);

  this.invoiceFormGroup
    .get('phoneNumber')
    ?.setValue(phone, { emitEvent: false });

  // Clear previous customer while typing
  if (phone.length !== 10) {

    this.customerDetails = null;
    this.customerAddresses = [];
    this.selectedCustomerAddress = null;

    this.customerWalletBalance = 0;
    this.walletDebitAmount = 0;
    this.walletCreditAmount = 0;
    this.isReduceFromWallet = false;

    this.invoiceFormGroup.patchValue({

      userRegId: 0,

      addressId: 0,

      customerName: '',

      userAddress: '',
      bulkAddress: '',

      doorNo: '',
      street: '',
      city: '',
      state: 'Tamil Nadu',
      pincode: '',

      userAddresses: []

    }, {
      emitEvent: false
    });

    return;
  }

  // Only call API for valid 10 digit number
  if (/^[6-9]\d{9}$/.test(phone)) {

    this.getCustomerByPhone(phone, false);

  }
}


  // ============================================================
  // CUSTOMER API
  // ============================================================

getCustomerByPhone(
  phone: string,
  isEdit: boolean = false
): void {

  phone = String(phone || '')
    .replace(/\D/g, '')
    .substring(0, 10);

  if (
    phone.length !== 10 ||
    !/^[6-9]\d{9}$/.test(phone)
  ) {
    return;
  }

  this.customerSearchLoading = true;

  this.appService
    .getUserByPhoneNumber(phone)
    .pipe(takeUntil(this.destroy$))
    .subscribe({

      next: (response: any) => {

        this.customerSearchLoading = false;

        if (!response) {

          this.clearCustomerDetails();

          this.toastr.warning(
            'Customer not found'
          );

          return;
        }

        // =====================================================
        // CUSTOMER
        // =====================================================

        this.customerDetails = response;

        // =====================================================
        // USER ID
        // =====================================================

        const userId =
          Number(
            response.userRegistrationId || 0
          );

        // =====================================================
        // WALLET
        // =====================================================

        this.customerWalletBalance =
          Number(
            response.walletBalance || 0
          );

        // =====================================================
        // CUSTOMER NAME + PHONE
        // =====================================================

        this.invoiceFormGroup.patchValue({

          userRegId: userId,

          customerName:
            response.name || '',

          phoneNumber:
            response.phoneNumber || phone

        }, {
          emitEvent: false
        });

        // =====================================================
        // CUSTOMER ADDRESSES
        // =====================================================

        const addresses =
          Array.isArray(response.userAddress)
            ? response.userAddress
            : [];

        // Always normalize bulkAddress
        this.customerAddresses =
          addresses.map((address: any) => ({

            ...address,

            bulkAddress:
              address.bulkAddress == null
                ? ''
                : String(address.bulkAddress)

          })).filter((item : any) => item.addressType != 'DELIVERY');

        // =====================================================
        // NO ADDRESS
        // =====================================================

        if (this.customerAddresses.length === 0) {

          this.selectedCustomerAddress = null;

          this.invoiceFormGroup.patchValue({

            addressId: 0,

            userAddress: '',
            bulkAddress: '',

            doorNo: '',
            street: '',
            city: '',
            state: 'Tamil Nadu',
            pincode: '',

            userAddresses: []

          }, {
            emitEvent: false
          });

        }

        // =====================================================
        // ONLY ONE ADDRESS
        // Automatically select
        // =====================================================

        else if (this.customerAddresses.length === 1) {

          this.setCustomerAddress(
            this.customerAddresses[0]
          );

        }

        // =====================================================
        // MULTIPLE ADDRESSES
        // Show dropdown
        // =====================================================

        else {

          /*
           * EDIT MODE:
           * Try to keep the address already saved in invoice.
           */
          if (isEdit) {

            const existingAddressId =
              Number(
                this.invoiceFormGroup
                  .get('addressId')
                  ?.value || 0
              );

            const existingAddress =
              this.customerAddresses.find(
                (address: any) =>
                  Number(address.addressId) ===
                  existingAddressId
              );

            if (existingAddress) {

              this.setCustomerAddress(
                existingAddress
              );

            } else {

              // Don't overwrite edit data
              this.selectedCustomerAddress = null;

            }

          } else {

            // New invoice:
            // Don't automatically select first address
            this.selectedCustomerAddress = null;

            this.invoiceFormGroup.patchValue({

              addressId: 0,

              userAddress: '',
              bulkAddress: '',

              userAddresses: []

            }, {
              emitEvent: false
            });

            this.toastr.info(
              'Please select delivery address'
            );
          }

        }

        // =====================================================
        // EDIT WALLET
        // =====================================================

        if (isEdit) {

          this.walletDebitAmount =
            this.originalWalletDebitAmount;

          this.walletCreditAmount =
            this.originalWalletCreditAmount;

          this.updateWalletCalculation();

        }

      },

      error: (error: any) => {

        this.customerSearchLoading = false;

        this.clearCustomerDetails();

        this.toastr.error(
          error?.error?.message ||
          'Failed to get customer details'
        );
      }

    });
}


clearCustomerDetails(): void {

  this.customerDetails = null;

  this.customerAddresses = [];

  this.selectedCustomerAddress = null;

  this.customerWalletBalance = 0;

  this.walletDebitAmount = 0;

  this.walletCreditAmount = 0;

  this.isReduceFromWallet = false;

  this.invoiceFormGroup.patchValue({

    userRegId: 0,

    customerName: '',

    addressId: 0,

    userAddress: '',
    bulkAddress: '',

    doorNo: '',
    street: '',
    city: '',
    state: 'Tamil Nadu',
    pincode: '',

    userAddresses: []

  }, {
    emitEvent: false
  });
}


  // ============================================================
  // SET CUSTOMER ADDRESS
  // ============================================================

  setCustomerAddress(address: any): void {

  if (!address) {
    return;
  }

  // Always convert null -> ""
  const bulkAddress =
    address.bulkAddress == null
      ? ''
      : String(address.bulkAddress);

  // Keep selected address
  this.selectedCustomerAddress = {

    ...address,

    bulkAddress: bulkAddress,

    buyerType:
      address.buyerType || 'USER'

  };

  // =====================================================
  // PATCH INVOICE ADDRESS
  // =====================================================

  this.invoiceFormGroup.patchValue({

    addressId:
      Number(address.addressId || 0),

    userRegId:
      Number(
        address.userId ||
        this.customerDetails?.userRegistrationId ||
        0
      ),

    customerName:
      address.name ||
      this.customerDetails?.name ||
      '',

    phoneNumber:
      address.phoneNumber ||
      this.customerDetails?.phoneNumber ||
      '',

    doorNo:
      address.doorNo || '',

    street:
      address.streetName || '',

    city:
      address.city || '',

    state:
      address.state || 'Tamil Nadu',

    pincode:
      address.pinCode || '',

    // IMPORTANT
    // Save API bulkAddress value
    userAddress:
      bulkAddress,

    // Also keep separately
    bulkAddress:
      bulkAddress,

    // Selected address only
    userAddresses: [
      {
        ...address,
        bulkAddress: bulkAddress,
        buyerType:
          address.buyerType || 'USER'
      }
    ]

  }, {
    emitEvent: false
  });

  // Shipping based on state
  if (
    this.invoiceFormGroup
      .get('billingType')
      ?.value === 'ONLINE'
  ) {

    this.onStateChange();

  }
}

onCustomerAddressChange(event: any): void {

  const addressId =
    Number(event.target.value || 0);

  if (!addressId) {

    this.selectedCustomerAddress = null;

    this.invoiceFormGroup.patchValue({

      addressId: 0,

      userAddress: '',
      bulkAddress: '',

      doorNo: '',
      street: '',
      city: '',
      state: 'Tamil Nadu',
      pincode: '',

      userAddresses: []

    }, {
      emitEvent: false
    });

    return;
  }

  const selectedAddress =
    this.customerAddresses.find(
      (address: any) =>
        Number(address.addressId) === addressId
    );

  if (selectedAddress) {

    this.setCustomerAddress(
      selectedAddress
    );

  }
}

  //get products form array function from invoice form group
  get products() {
    return this.invoiceFormGroup.get('products') as UntypedFormArray;
  }

  onBarcodeInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const barcode = input.value.trim();

    if (!barcode) return;

    if (event.key !== 'Enter') return; // Only act on Enter key

    // Clear input immediately for next scan
    input.value = '';

    // Avoid duplicate scans
    if (this.scannedBarcodes.has(barcode)) {
      this.toastr.info('Barcode already scanned');
      this.refocusScanner();
      return;
    }
    this.scannedBarcodes.add(barcode);

    this.lookupBarcode(barcode);
  }

  lookupBarcode(barcode: string) {

    this.spinner.show();

    this.appService.getByBarcodeDetails(barcode).subscribe({
      next: (res) => {

        this.spinner.hide();

        const variants = res?.ProductVariantDetails;

        if (!variants?.length) {
          this.toastr.warning('Product not found');
          this.refocusScanner();
          return;
        }

        // 🔥 PICK AVAILABLE SIZE
        const selectedVariant = variants.find(v =>
          this.getAllowedStock(v) > 0
        );

        if (!selectedVariant) {
          this.toastr.error("Out of stock product cannot be added");
          this.refocusScanner();
          return;
        }

        const existingRow = this.findExistingRow(
          selectedVariant.barcodeNumber,
          selectedVariant.productVariantId,
          selectedVariant.size
        );

        if (existingRow) {

          let qty = Number(existingRow.get('quantity')?.value || 0) + 1;

          const allowed = this.getAllowedStock(selectedVariant, existingRow);

          if (qty > allowed) {
            this.toastr.warning(`Only ${allowed} allowed`);
            return;
          }

          existingRow.patchValue({
            quantity: qty,
            totalPrice: qty * selectedVariant.productSrp
          });

          this.afterRowUpdate();
          return;
        }

        this.addItem(selectedVariant);

        const index = this.products.length - 1;

        // ✅ IMPORTANT: load category
        if (selectedVariant.categoryId) {
          this.categoryDetailsGetById(selectedVariant.categoryId);
        }

        this.productVariants[index] = variants;

        this.afterRowUpdate();

        this.toastr.success('Product added');
        this.refocusScanner();
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error('Barcode lookup failed.');
        this.refocusScanner();
      }
    });
  }

  // ============================================================
  // WALLET CHECKBOX CHANGE
  // ============================================================

  onWalletChange(): void {

    this.updateWalletCalculation();

  }


  // ============================================================
  // WALLET CALCULATION
  // ============================================================

  // ============================================================
  // NEW / EDIT WALLET CALCULATION
  // ============================================================

  updateWalletCalculation(): void {

  const totalAmount =
    Number(
      this.invoiceFormGroup
        .get('totalAmount')
        ?.value || 0
    );


  const paidAmount =
    Math.max(
      Number(
        this.invoiceFormGroup
          .get('paidAmount')
          ?.value || 0
      ),
      0
    );


  const walletBalance =
    Math.max(
      Number(
        this.customerWalletBalance || 0
      ),
      0
    );


  // ==========================================================
  // NO TOTAL
  // ==========================================================

  if (totalAmount <= 0) {

    this.walletDebitAmount = 0;

    this.walletCreditAmount = 0;

    this.invoiceFormGroup.patchValue({

      walletDebitAmount: 0,

      walletCreditAmount: 0,

      dueAmount: 0,

      isReduceFromWallet: false

    }, {
      emitEvent: false
    });

    return;
  }


  // ==========================================================
  // EDIT MODE
  // ==========================================================

  if (this.isUpdate) {

    const oldWalletDebit =
      Number(
        this.originalWalletDebitAmount || 0
      );


    const oldWalletCredit =
      Number(
        this.originalWalletCreditAmount || 0
      );


    // ========================================================
    // AMOUNT AFTER PAYMENT
    // ========================================================

    const amountAfterPayment =
      Math.max(
        totalAmount -
        paidAmount,
        0
      );


    let newWalletDebit = 0;


    // ========================================================
    // WALLET SELECTED
    // ========================================================

    if (this.isReduceFromWallet) {

      // Existing wallet debit can be retained
      const existingDebit =
        Math.min(
          oldWalletDebit,
          amountAfterPayment
        );


      // Additional wallet required
      const additionalRequired =
        Math.max(
          amountAfterPayment -
          existingDebit,
          0
        );


      // Latest wallet balance from phone API
      const additionalDebit =
        Math.min(
          additionalRequired,
          walletBalance
        );


      newWalletDebit =
        existingDebit +
        additionalDebit;


      newWalletDebit =
        Math.min(
          newWalletDebit,
          amountAfterPayment
        );
    }


    // ========================================================
    // AMOUNT AFTER WALLET
    // ========================================================

    const amountAfterWallet =
      Math.max(
        totalAmount -
        newWalletDebit,
        0
      );


    // ========================================================
    // PAYMENT
    // ========================================================

    const actualPaid =
      Math.min(
        paidAmount,
        amountAfterWallet
      );


    // ========================================================
    // EXTRA PAYMENT -> WALLET CREDIT
    // ========================================================

    const newWalletCredit =
      Math.max(
        paidAmount -
        amountAfterWallet,
        0
      );


    // ========================================================
    // DUE
    // ========================================================

    const dueAmount =
      Math.max(
        amountAfterWallet -
        actualPaid,
        0
      );


    // ========================================================
    // SET VALUES
    // ========================================================

    this.walletDebitAmount =
      Number(
        newWalletDebit.toFixed(2)
      );


    this.walletCreditAmount =
      Number(
        newWalletCredit.toFixed(2)
      );


    // ========================================================
    // PATCH FORM
    // ========================================================

    this.invoiceFormGroup.patchValue({

      dueAmount:
        Number(
          dueAmount.toFixed(2)
        ),

      walletDebitAmount:
        this.walletDebitAmount,

      walletCreditAmount:
        this.walletCreditAmount,

      isReduceFromWallet:
        this.isReduceFromWallet

    }, {
      emitEvent: false
    });

    return;
  }


  // ==========================================================
  // NEW INVOICE
  // ==========================================================

  let walletDebit = 0;


  if (
    this.isReduceFromWallet &&
    walletBalance > 0
  ) {

    walletDebit =
      Math.min(
        walletBalance,
        Math.max(
          totalAmount -
          paidAmount,
          0
        )
      );
  }


  const amountAfterWallet =
    Math.max(
      totalAmount -
      walletDebit,
      0
    );


  const actualPaid =
    Math.min(
      paidAmount,
      amountAfterWallet
    );


  const walletCredit =
    Math.max(
      paidAmount -
      amountAfterWallet,
      0
    );


  const dueAmount =
    Math.max(
      amountAfterWallet -
      actualPaid,
      0
    );


  this.walletDebitAmount =
    Number(
      walletDebit.toFixed(2)
    );


  this.walletCreditAmount =
    Number(
      walletCredit.toFixed(2)
    );


  this.invoiceFormGroup.patchValue({

    dueAmount:
      Number(
        dueAmount.toFixed(2)
      ),

    walletDebitAmount:
      this.walletDebitAmount,

    walletCreditAmount:
      this.walletCreditAmount,

    isReduceFromWallet:
      this.walletDebitAmount > 0

  }, {
    emitEvent: false
  });
}


  // ============================================================
  // NEW INVOICE WALLET CALCULATION
  // ============================================================

  private calculateWalletForNewInvoice(
    totalAmount: number,
    paidAmount: number,
    walletBalance: number
  ): void {

    let walletDebit = 0;


    // ----------------------------------------------------------
    // Wallet can be used
    // ----------------------------------------------------------

    if (
      this.isReduceFromWallet &&
      walletBalance > 0
    ) {

      walletDebit =
        Math.min(
          walletBalance,
          totalAmount
        );
    }


    // ----------------------------------------------------------
    // Amount remaining after wallet
    // ----------------------------------------------------------

    const amountAfterWallet =
      Math.max(
        totalAmount -
        walletDebit,
        0
      );


    // ----------------------------------------------------------
    // Customer payment
    // ----------------------------------------------------------

    const actualPaid =
      Math.min(
        paidAmount,
        amountAfterWallet
      );


    // ----------------------------------------------------------
    // Extra payment becomes wallet credit
    // ----------------------------------------------------------

    const walletCredit =
      Math.max(
        paidAmount -
        amountAfterWallet,
        0
      );


    // ----------------------------------------------------------
    // Due
    // ----------------------------------------------------------

    const dueAmount =
      Math.max(
        amountAfterWallet -
        actualPaid,
        0
      );


    // ----------------------------------------------------------
    // Save values
    // ----------------------------------------------------------

    this.walletDebitAmount =
      Number(
        walletDebit.toFixed(2)
      );


    this.walletCreditAmount =
      Number(
        walletCredit.toFixed(2)
      );


    // ----------------------------------------------------------
    // Update form
    // ----------------------------------------------------------

    this.invoiceFormGroup.patchValue({

      paidAmount:
        Number(
          paidAmount.toFixed(2)
        ),

      dueAmount:
        Number(
          dueAmount.toFixed(2)
        ),

      walletDebitAmount:
        this.walletDebitAmount,

      walletCreditAmount:
        this.walletCreditAmount,

      isReduceFromWallet:
        this.walletDebitAmount > 0

    }, {
      emitEvent: false
    });
  }


  // ============================================================
  // EDIT / UPDATE WALLET CALCULATION
  // ============================================================

  private calculateWalletForUpdate(
    totalAmount: number,
    paidAmount: number,
    walletBalance: number
  ): void {

    // ----------------------------------------------------------
    // IMPORTANT
    //
    // originalWalletDebitAmount is the wallet amount already
    // used by the existing invoice.
    //
    // Do NOT use current wallet balance as a fresh wallet amount.
    // ----------------------------------------------------------

    const oldWalletDebit =
      Number(
        this.originalWalletDebitAmount || 0
      );


    const oldWalletCredit =
      Number(
        this.originalWalletCreditAmount || 0
      );


    // ==========================================================
    // STEP 1
    // ==========================================================

    // Amount that still needs to be covered after customer's
    // current payment.

    const amountAfterPayment =
      Math.max(
        totalAmount -
        paidAmount,
        0
      );


    // ==========================================================
    // STEP 2
    // ==========================================================
    // If wallet option is enabled:
    //
    // Existing wallet debit is reused.
    //
    // New required wallet amount is calculated from current
    // invoice amount.
    // ==========================================================

    let newWalletDebit = 0;


    if (this.isReduceFromWallet) {

      // Existing wallet debit can remain.
      newWalletDebit =
        Math.min(
          oldWalletDebit,
          amountAfterPayment
        );


      // --------------------------------------------------------
      // Additional wallet amount required
      // --------------------------------------------------------

      const additionalWalletRequired =
        Math.max(
          amountAfterPayment -
          oldWalletDebit,
          0
        );


      // Available wallet balance is the current balance.
      // Existing wallet debit is already represented by the
      // previous transaction, so only add the additional amount.
      //
      // This is important for edit.
      // --------------------------------------------------------

      const additionalWalletDebit =
        Math.min(
          additionalWalletRequired,
          walletBalance
        );


      newWalletDebit =
        oldWalletDebit +
        additionalWalletDebit;


      // Never exceed invoice amount
      newWalletDebit =
        Math.min(
          newWalletDebit,
          amountAfterPayment
        );
    }


    // ==========================================================
    // STEP 3
    // ==========================================================
    // Amount covered by wallet
    // ==========================================================

    const amountAfterWallet =
      Math.max(
        totalAmount -
        newWalletDebit,
        0
      );


    // ==========================================================
    // STEP 4
    // ==========================================================

    const actualPaid =
      Math.min(
        paidAmount,
        amountAfterWallet
      );


    // ==========================================================
    // STEP 5
    // ==========================================================
    // Customer pays more than required.
    // Extra amount becomes wallet credit.
    // ==========================================================

    const newWalletCredit =
      Math.max(
        paidAmount -
        amountAfterWallet,
        0
      );


    // ==========================================================
    // STEP 6
    // ==========================================================

    const dueAmount =
      Math.max(
        amountAfterWallet -
        actualPaid,
        0
      );


    // ==========================================================
    // STEP 7
    // ==========================================================
    // Difference between old and new wallet debit.
    //
    // Example:
    //
    // Old debit = 300
    // New debit = 500
    // Difference = +200
    //
    // Backend should debit additional 200.
    //
    // Old debit = 300
    // New debit = 100
    // Difference = -200
    //
    // Backend should return 200 to wallet.
    // ==========================================================

    const walletDebitDifference =
      newWalletDebit -
      oldWalletDebit;


    const walletCreditDifference =
      newWalletCredit -
      oldWalletCredit;


    // ==========================================================
    // FINAL VALUES
    // ==========================================================

    this.walletDebitAmount =
      Number(
        newWalletDebit.toFixed(2)
      );


    this.walletCreditAmount =
      Number(
        newWalletCredit.toFixed(2)
      );


    // ==========================================================
    // PATCH FORM
    // ==========================================================

    this.invoiceFormGroup.patchValue({

      paidAmount:
        Number(
          paidAmount.toFixed(2)
        ),

      dueAmount:
        Number(
          dueAmount.toFixed(2)
        ),

      walletDebitAmount:
        this.walletDebitAmount,

      walletCreditAmount:
        this.walletCreditAmount,

      isReduceFromWallet:
        this.walletDebitAmount > 0

    }, {
      emitEvent: false
    });

  }

  // ============================================================
  // LOAD ORIGINAL WALLET VALUES
  // ============================================================

  loadOriginalWalletValues(bill: any): void {

  // ==========================================================
  // ORIGINAL INVOICE WALLET DEBIT
  // ==========================================================

  this.originalWalletDebitAmount =
    Number(
      bill?.walletDebitAmount || 0
    );


  // ==========================================================
  // ORIGINAL INVOICE WALLET CREDIT
  // ==========================================================

  this.originalWalletCreditAmount =
    Number(
      bill?.walletCreditAmount || 0
    );


  // ==========================================================
  // ORIGINAL TOTAL
  // ==========================================================

  this.originalInvoiceTotal =
    Number(
      bill?.totalAmount || 0
    );


  // ==========================================================
  // ORIGINAL PAID
  // ==========================================================

  this.originalPaidAmount =
    Number(
      bill?.paidAmount || 0
    );


  // ==========================================================
  // ORIGINAL DUE
  // ==========================================================

  this.originalDueAmount =
    Number(
      bill?.dueAmount || 0
    );


  // ==========================================================
  // WALLET ENABLED IN ORIGINAL BILL
  // ==========================================================

  this.isReduceFromWallet =
    Boolean(
      bill?.isReduceFromWallet ||
      bill?.isReduceFromWallet ||
      this.originalWalletDebitAmount > 0
    );


  // ==========================================================
  // DISPLAY EXISTING WALLET AMOUNTS
  // ==========================================================

  this.walletDebitAmount =
    this.originalWalletDebitAmount;


  this.walletCreditAmount =
    this.originalWalletCreditAmount;
    
}


  // Re-focus scanner input
  refocusScanner() {
    setTimeout(() => {
      this.scannerInput.nativeElement.focus();
    }, 50);
  }



  //add form array based on form group
  addItem(product?: any) {

    const available = Number(product?.availableStock || 0);
    const reserved = Number(product?.reservedQuantity || 0);

    const group = new UntypedFormGroup({

      productId: new UntypedFormControl(product?.productId || 0),
      productVariantId: new UntypedFormControl(product?.productVariantId || 0),

      productName: new UntypedFormControl(product?.productName || ''),
      size: new UntypedFormControl(product?.size || ''),

      quantity: new UntypedFormControl(1),
      unitPrice: new UntypedFormControl(product?.productSrp || 0),
      totalPrice: new UntypedFormControl(product?.productSrp || 0),

      availableStock: new UntypedFormControl(available),
      oldQuantity: new UntypedFormControl(product?.quantity || 0),

      discounts: new UntypedFormControl(product?.discounts || []),

      barcodeNumber: new UntypedFormControl(product?.barcodeNumber || ''),
      productCode: new UntypedFormControl(product?.barcodeNumber || ''),

      categoryId: new UntypedFormControl(product?.categoryId || 0),
    });

    this.products.push(group);

    group.get('quantity')?.valueChanges.subscribe(() => {
      this.recalculateCart();
    });

    this.recalculateCart();
  }

  addEmptyItem() {

    const productGroup = new UntypedFormGroup({
      billingItemId: new UntypedFormControl(0),
      productId: new UntypedFormControl(0),
      productVariantId: new UntypedFormControl(0),

      productCode: new UntypedFormControl(''),
      barcodeNumber: new UntypedFormControl(''),

      productName: new UntypedFormControl(''),
      size: new UntypedFormControl(''),

      quantity: new UntypedFormControl(1),
      unitPrice: new UntypedFormControl(0),
      totalPrice: new UntypedFormControl(0),

      categoryId: new UntypedFormControl(0),

      discount: new UntypedFormControl(0),
      discounts: new UntypedFormControl([]),

      availableStock: new UntypedFormControl(0),
      oldQuantity: new UntypedFormControl(0)

    });

    this.products.push(productGroup);
  }

  addManualShopItem() {

    const productGroup = new UntypedFormGroup({

      billingItemId: new UntypedFormControl(0),
      billId: new UntypedFormControl(0),

      productId: new UntypedFormControl(0), // manual
      productVariantId: new UntypedFormControl(0),

      productCode: new UntypedFormControl(''),
      barcodeNumber: new UntypedFormControl(''),

      productName: new UntypedFormControl('', Validators.required),
      size: new UntypedFormControl(''),

      quantity: new UntypedFormControl(1, [Validators.required, Validators.min(1)]),
      unitPrice: new UntypedFormControl(0, [Validators.required, Validators.min(0)]),

      totalPrice: new UntypedFormControl(0),

      categoryId: new UntypedFormControl(0),

      discounts: new UntypedFormControl([]),
      discount: new UntypedFormControl(0),

      availableStock: new UntypedFormControl(999999), // unlimited
      oldQuantity: new UntypedFormControl(0)

    });

    this.products.push(productGroup);

    // ✅ ONLY THIS (no double calc)
    productGroup.valueChanges.subscribe(() => {
      this.updateItemTotal(productGroup);
      this.recalculateCart();
    });

    this.updateItemTotal(productGroup);
  }

  getAllowedStock(variant: any, row?: UntypedFormGroup): number {

    const billingType = this.invoiceFormGroup.get('billingType')?.value;

    const available = Number(variant?.availableStock ?? 0);
    const reserved = Number(variant?.reservedQuantity ?? 0);

    const oldQty = Number(row?.get('oldQuantity')?.value || 0);
    const isEditRow = oldQty > 0;

    const variantId = variant?.productVariantId;

    // ✅ subtract other rows usage
    const usedQty = this.getUsedQtyForVariant(variantId, row);

    // ================= SHOP =================
    if (billingType === 'SHOP') {

      if (isEditRow) {
        return (available + oldQty) - usedQty;
      }

      return available - usedQty;
    }

    // ================= ONLINE =================
    if (billingType === 'ONLINE') {

      if (isEditRow) {
        return (available + oldQty) - usedQty;
      }

      return (available + reserved) - usedQty;
    }

    return available - usedQty;
  }


  findExistingRow(barcode: string, variantId: number, size: string): UntypedFormGroup | null {

    return this.products.controls.find((row: any) => {

      return (
        (row.get('barcodeNumber')?.value === barcode) &&
        (Number(row.get('productVariantId')?.value) === Number(variantId)) &&
        (row.get('size')?.value === size)
      );

    }) as UntypedFormGroup || null;
  }

  getUsedQtyForVariant(variantId: number, currentRow?: UntypedFormGroup): number {

    let total = 0;

    this.products.controls.forEach((row: any) => {

      if (row === currentRow) return;

      const rowVariantId = Number(row.get('productVariantId')?.value || 0);

      if (rowVariantId === variantId) {
        total += Number(row.get('quantity')?.value || 0);
      }

    });

    return total;
  }

  isDuplicateRow(barcode: string, size: string, currentIndex?: number): boolean {

    return this.products.controls.some((row: any, index: number) => {

      if (index === currentIndex) return false;

      const rowBarcode = row.get('barcodeNumber')?.value;
      const rowSize = row.get('size')?.value;

      return rowBarcode === barcode && rowSize === size;
    });
  }

  updateItemTotal(group: any) {

    const qty = Number(group.get('quantity')?.value || 0);

    const price = Number(group.get('unitPrice')?.value || 0);

    group.patchValue({
      totalPrice: qty * price
    }, { emitEvent: false });
  }

  onSizeChange(index: number) {

    const row = this.products.at(index) as UntypedFormGroup;
    const selectedSize = row.get('size')?.value;
    const variants = this.productVariants[index];

    if (!variants?.length) return;

    let selectedVariant = variants.find(v => v.size === selectedSize);

    if (!selectedVariant) {
      this.clearRow(row);
      return;
    }

    let allowedStock = this.getAllowedStock(selectedVariant, row);

    // 🔥 AUTO SWITCH SIZE IF NO STOCK
    if (allowedStock <= 0) {

      const availableVariant = variants
        .filter(v => this.getAllowedStock(v, row) > 0)
        .sort((a, b) =>
          this.getAllowedStock(b, row) - this.getAllowedStock(a, row)
        )[0];

      if (this.isDuplicateRow(selectedVariant.barcodeNumber, selectedVariant.size, index)) {
        this.toastr.warning("Duplicate size not allowed");
        row.get('size')?.setValue('');
        return;
      }

      if (availableVariant) {

        this.toastr.info(`Switched to available size ${availableVariant.size}`);

        selectedVariant = availableVariant;
        allowedStock = this.getAllowedStock(selectedVariant, row);

        row.get('size')?.setValue(selectedVariant.size, { emitEvent: false });

      } else {

        this.toastr.error("No stock available for any size");
        this.clearRow(row);
        return;
      }
    }

    let currentQty = Number(row.get('quantity')?.value || 1);

    // 🔥 RESET QTY WHEN VARIANT CHANGE
    const prevVariant = row.get('productVariantId')?.value;
    if (prevVariant !== selectedVariant.productVariantId) {
      currentQty = 1;
    }

    // 🔥 FIX QTY LIMIT
    if (currentQty > allowedStock) {
      currentQty = allowedStock;
      this.toastr.warning(`Max allowed qty: ${allowedStock}`);
    }

    if (allowedStock <= 0) currentQty = 1;
    if (currentQty < 1) currentQty = 1;

    row.patchValue({

      productVariantId: selectedVariant.productVariantId,
      barcodeNumber: selectedVariant.barcodeNumber,
      productCode: selectedVariant.barcodeNumber,
      productName: selectedVariant.productName,

      unitPrice: selectedVariant.productSrp,

      availableStock: Number(selectedVariant.availableStock || 0),
      oldQuantity: Number(selectedVariant.reservedQuantity || 0),

      quantity: currentQty,
      totalPrice: currentQty * selectedVariant.productSrp,

      categoryId: selectedVariant.categoryId

    }, { emitEvent: false });

    this.afterRowUpdate();
  }

  recalculateCart() {

    let productTotal = 0;
    let discountTotal = 0;

    let totalQty = 0;

    // ✅ TOTAL QTY
    this.products.controls.forEach((row: any) => {
      totalQty += Number(row.get('quantity')?.value || 0);
    });

    // ✅ FIND MIN DISCOUNT QTY (example: 5)
    let minQty = 0;

    this.products.controls.forEach((row: any) => {
      const discounts = row.get('discounts')?.value || [];

      if (discounts.length > 0) {
        minQty = discounts[0].discountQuantity;
      }
    });

    // ❌ NOT ELIGIBLE
    if (totalQty < minQty) {

      this.products.controls.forEach((row: any) => {

        const qty = Number(row.get('quantity')?.value || 0);
        const price = Number(row.get('unitPrice')?.value || 0);

        const rowTotal = qty * price;

        productTotal += rowTotal;

        row.patchValue({
          discount: 0,
          totalPrice: rowTotal
        }, { emitEvent: false });

      });

      this.productTotal = productTotal;
      this.discountTotal = 0;
      this.updateTotalAmount();
      return;
    }

    // ✅ ELIGIBLE QTY
    let remainingEligibleQty = totalQty;

    // ✅ APPLY DISCOUNT ROW BY ROW
    this.products.controls.forEach((row: any) => {

      const qty = Number(row.get('quantity')?.value || 0);
      const price = Number(row.get('unitPrice')?.value || 0);
      const discounts = row.get('discounts')?.value || [];

      let unitDiscount = 0;

      if (discounts.length > 0) {
        const slab = discounts
          .filter((d: any) => totalQty >= d.discountQuantity) // ✅ based on TOTAL QTY
          .sort((a: any, b: any) => b.discountQuantity - a.discountQuantity)[0];

        if (slab) {
          unitDiscount = Number(slab.discountAmount);
        }
      }

      const rowTotal = qty * price;
      const rowDiscount = qty * unitDiscount;

      productTotal += rowTotal;
      discountTotal += rowDiscount;

      row.patchValue({
        discount: rowDiscount,
        totalPrice: rowTotal
      }, { emitEvent: false });

    });

    this.productTotal = productTotal;
    this.discountTotal = discountTotal;

    this.updateTotalAmount();

    // if (this.invoiceFormGroup.value.billingType === 'ONLINE') {
    //   const state = this.invoiceFormGroup.get('state')?.value;
    //   this.calculateItemWiseShipping(state);
    // }
  }


  onStateChange() {

    const state = this.invoiceFormGroup.get('state')?.value;

    if (!state) return;

    this.selectedState = state;

    if (this.invoiceFormGroup.value.billingType === 'ONLINE') {

      this.calculateItemWiseShipping(state);

    }

  }

  onQtyChange(index: number) {

    const row = this.products.at(index) as UntypedFormGroup;

    let qty = Number(row.get('quantity')?.value || 0);

    const variant = {
      availableStock: row.get('availableStock')?.value,
      reservedQuantity: row.get('oldQuantity')?.value,
      productVariantId: row.get('productVariantId')?.value
    };

    const maxQty = this.getAllowedStock(variant, row);

    if (qty > maxQty) {
      qty = maxQty;
      this.toastr.warning(`Only ${maxQty} allowed`);
    }

    if (qty < 1) qty = 1;

    row.patchValue({
      quantity: qty,
      totalPrice: qty * Number(row.get('unitPrice')?.value || 0)
    }, { emitEvent: false });

    this.afterRowUpdate();
  }

  afterRowUpdate() {

    const billingType = this.invoiceFormGroup.get('billingType')?.value;
    const state = this.invoiceFormGroup.get('state')?.value;

    // ✅ FIRST recalc totals
    this.recalculateCart();

    // ✅ THEN shipping (IMPORTANT ORDER)
    if (billingType === 'ONLINE') {

      if (this.categoryDetails.length === 0) {
        // ❗ wait until categories loaded
        return;
      }

      this.calculateItemWiseShipping(state);
    }
  }

  calculateRowTotal(row: UntypedFormGroup) {

    const qty = Number(row.get('quantity')?.value || 0);
    const price = Number(row.get('unitPrice')?.value || 0);
    const discounts = row.get('discounts')?.value || [];

    let unitDiscount = 0;

    if (discounts.length > 0) {
      const slab = discounts
        .filter((d: any) => qty >= d.discountQuantity)
        .sort((a: any, b: any) => b.discountQuantity - a.discountQuantity)[0];

      if (slab) {
        unitDiscount = Number(slab.discountAmount);
      }
    }

    const rowTotal = qty * price;
    const rowDiscount = qty * unitDiscount;

    row.patchValue({
      discount: rowDiscount,
      totalPrice: rowTotal
    }, { emitEvent: false });

  }


  // Function to calculate subtotal
  updateSubTotal() {
    const productsArray = this.invoiceFormGroup.get('products') as UntypedFormArray;
    let subTotal = 0;

    productsArray.controls.forEach(product => {
      const totalPrice = Number(product.get('totalPrice')?.value) || 0;
      subTotal += totalPrice;
    });

    this.invoiceFormGroup.get('subTotal')?.setValue(Number(subTotal.toFixed(2)), { emitEvent: false });
    this.updateTotalAmount();
  }

  onManualDiscountChange() {

    let input = Number(this.invoiceFormGroup.get('manualDiscountAmount')?.value || 0);

    const subTotal = this.productTotal || 0;
    const productDiscount = this.discountTotal || 0;
    const shipping = this.shipping || 0;
    const previousPaid = this.previousPaidAmount || 0;

    // ✅ due BEFORE manual discount
    let dueBeforeManual = (subTotal + shipping - productDiscount) - previousPaid;

    if (dueBeforeManual < 0) dueBeforeManual = 0;

    // ❌ block negative
    if (input < 0) {
      input = 0;
    }

    // ❌ block over discount
    if (input > dueBeforeManual) {
      input = dueBeforeManual;
    }

    // ✅ system overrides user input
    this.manualDiscount = input;

    this.invoiceFormGroup.patchValue({
      manualDiscountAmount: input
    }, { emitEvent: false });

    this.updateTotalAmount();
  }

  getBaseStock(variant: any): number {
    return Number(
      variant?.availableStock ??
      variant?.varientQuantity ??
      0
    );
  }


  onPaidAmountInput(): void {

    let value =
      Number(
        this.invoiceFormGroup
          .get('paidAmount')
          ?.value || 0
      );

    if (value < 0) {
      value = 0;
    }

    this.invoiceFormGroup.patchValue({

      paidAmount: value

    }, {
      emitEvent: false
    });

    this.updateWalletCalculation();
  }


  getMaxManualDiscount(): number {

    const subTotal = this.productTotal || 0;
    const productDiscount = this.discountTotal || 0;
    const shipping = this.shipping || 0;
    const previousPaid = this.previousPaidAmount || 0;

    let max = (subTotal + shipping - productDiscount) - previousPaid;

    return max > 0 ? max : 0;
  }


  updateTotalAmount(): void {

    const subTotal =
      this.productTotal || 0;

    const productDiscount =
      this.discountTotal || 0;

    const shipping =
      this.shipping || 0;

    const previousPaid =
      this.previousPaidAmount || 0;

    let dueBeforeManual =
      (
        subTotal +
        shipping -
        productDiscount
      ) -
      previousPaid;

    if (dueBeforeManual < 0) {
      dueBeforeManual = 0;
    }

    let manualDiscount =
      this.manualDiscount || 0;

    if (manualDiscount < 0) {
      manualDiscount = 0;
    }

    if (
      manualDiscount >
      dueBeforeManual
    ) {

      manualDiscount =
        dueBeforeManual;

    }

    let totalAmount =
      subTotal +
      shipping -
      productDiscount -
      manualDiscount;

    if (totalAmount < 0) {
      totalAmount = 0;
    }

    let paid =
      Number(
        this.invoiceFormGroup
          .get('paidAmount')
          ?.value || 0
      );

    if (paid < 0) {
      paid = 0;
    }

    // ==========================================
    // NORMAL DUE
    // ==========================================

    const maxPaid =
      Math.max(
        totalAmount -
        previousPaid,
        0
      );

    // Do not allow negative payment
    if (paid < 0) {
      paid = 0;
    }

    // ==========================================
    // Update form total first
    // ==========================================

    this.invoiceFormGroup.patchValue({

      subTotal:
        Number(
          subTotal.toFixed(2)
        ),

      totalAmount:
        Number(
          totalAmount.toFixed(2)
        ),

      manualDiscountAmount:
        Number(
          manualDiscount.toFixed(2)
        )

    }, {
      emitEvent: false
    });

    this.manualDiscount =
      manualDiscount;

    // ==========================================
    // WALLET
    // ==========================================

    this.updateWalletCalculation();

  }

  getRemainingAmount(): number {
    const total = Number(this.invoiceFormGroup.get('totalAmount')?.value || 0);
    const oldPaid = this.previousPaidAmount || 0;

    return Math.max(total - oldPaid, 0);
  }
  //remove products form array functionality
  removeItem(index: number) {

    if (this.products.length <= 1) {
      this.toastr.error('At least one product item is required.');
      return;
    }

    const row = this.products.at(index);

    const billingItemId = row.get('billingItemId')?.value;

    const barcode = row.get('barcodeNumber')?.value;

    // remove scanned cache
    if (barcode && this.scannedBarcodes.has(barcode)) {
      this.scannedBarcodes.delete(barcode);
    }

    // ================= NEW ROW =================
    if (!billingItemId || billingItemId == 0) {

      this.products.removeAt(index);
      this.afterRowUpdate();

      this.toastr.success('Item removed (local)');
      return;
    }

    // ================= SERVER DELETE =================
    this.spinner.show();

    this.appService.deleteIdByBillItem(billingItemId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({

        next: () => {

          this.spinner.hide();

          // remove from UI
          this.products.removeAt(index);

          // remove from local cache
          this.currentBillingDetails.products =
            this.currentBillingDetails.products.filter(
              (item: any) => item.billingItemId !== billingItemId
            );

          this.afterRowUpdate();

          this.toastr.success('Item deleted successfully');
        },

        error: (error: any) => {
          this.spinner.hide();
          this.toastr.error(error.error?.message || "Delete failed");
        }
      });
  }
  onBarcodeChange(index: number) {

    const row = this.products.at(index) as UntypedFormGroup;

    const value = (row.get('barcodeNumber')?.value || '').trim();

    if (!value || value.length < 2) return; // avoid empty calls

    this.barcodeSubject.next({ index, value });
  }

  fetchBarcode(index: number, barcode: string) {

    const row = this.products.at(index) as UntypedFormGroup;

    // ✅ DO NOT FULL RESET (causes issues)
    row.patchValue({
      productId: 0,
      productVariantId: 0,
      productName: '',
      size: '',
      quantity: 1,
      unitPrice: 0,
      totalPrice: 0,
      availableStock: 0,
      oldQuantity: 0,
      discounts: [],
      barcodeNumber: barcode,
      productCode: barcode
    }, { emitEvent: false });

    this.appService.getByBarcodeDetails(barcode).subscribe((res: any) => {

      const variants = res?.productVariantDetails || [];

      if (!variants.length) {
        this.clearRow(row);
        this.toastr.warning("Invalid barcode");
        return;
      }

      // ✅ SAVE ALL VARIANTS
      this.productVariants[index] = variants;

      // 🔥 STEP 1: FILTER AVAILABLE VARIANTS
      const availableVariants = variants.filter((v: any) =>
        this.getAllowedStock(v, row) > 0
      );

      if (!availableVariants.length) {
        this.toastr.error("All sizes are out of stock");
        this.clearRow(row);
        return;
      }

      // 🔥 STEP 2: REMOVE DUPLICATES
      const nonDuplicateVariants = availableVariants.filter((v: any) =>
        !this.isDuplicateRow(v.barcodeNumber, v.size, index)
      );

      if (!nonDuplicateVariants.length) {
        this.toastr.warning("All sizes already added for this barcode");
        this.clearRow(row);
        return;
      }

      // ✅ FINAL SELECT
      const selectedVariant = nonDuplicateVariants[0];

      const available = Number(selectedVariant.availableStock || 0);

      if (selectedVariant.categoryId) {
        this.categoryDetailsGetById(selectedVariant.categoryId);
      }

      row.patchValue({

        productId: selectedVariant.productId,
        productVariantId: selectedVariant.productVariantId,
        productName: selectedVariant.productName,

        barcodeNumber: selectedVariant.barcodeNumber,
        productCode: selectedVariant.barcodeNumber,

        quantity: 1,
        unitPrice: selectedVariant.productSrp,
        totalPrice: selectedVariant.productSrp,

        categoryId: selectedVariant.categoryId,
        discounts: res?.discounts || [],

        availableStock: available,

        // ✅ CRITICAL FIX (EDIT SAFE)
        oldQuantity: row.get('oldQuantity')?.value || 0

      }, { emitEvent: false });

      // ✅ SET SIZE AFTER PATCH
      row.get('size')?.setValue(selectedVariant.size, { emitEvent: false });

      this.afterRowUpdate();
    });
  }

  categoryDetailsGetById(catId: number) {

    if (!catId) return;

    const exists = this.categoryDetails.find(c => c.categoryId === catId);
    if (exists) return;

    this.appService.categoryGetById({ categoryId: catId })
      .subscribe((catRes: any) => {

        this.categoryDetails.push(catRes);

        // ✅ AUTO RECALCULATE SHIPPING
        const state = this.invoiceFormGroup.get('state')?.value;

        if (this.invoiceFormGroup.value.billingType === 'ONLINE') {
          this.calculateItemWiseShipping(state);
        }

      });
  }

  getZoneByState(state: string): string {

    if (!state) return '';

    const s = state.trim().toLowerCase();

    if (this.tamilNaduStates.has(s)) return 'Tamil Nadu';

    if (this.southIndiaStates.has(s)) return 'South India';

    return 'North India';
  }

  calculateItemWiseShipping(selectedState: string) {

    if (!selectedState || this.products.length === 0) {
      this.shippingDetails = [];
      this.selectedShipping = null;
      this.shipping = 0;
      this.updateTotalAmount();
      return;
    }

    const zone = this.getZoneByState(selectedState);

    interface PartnerSummary {
      shippingPartner: string;
      amount: number;
      free: boolean;
      flatApplied: Set<string>;
    }

    const partnerMap = new Map<string, PartnerSummary>();

    // ✅ STEP 1: CATEGORY TOTAL QTY MAP (IMPORTANT FIX)
    const categoryQtyMap = new Map<number, number>();

    this.products.controls.forEach((row: any) => {

      const categoryId = Number(row.get('categoryId')?.value || 0);
      const qty = Number(row.get('quantity')?.value || 0);

      if (!categoryId || qty <= 0) return;

      categoryQtyMap.set(
        categoryId,
        (categoryQtyMap.get(categoryId) || 0) + qty
      );
    });

    // ================= MAIN LOOP =================
    this.products.controls.forEach((row: any) => {

      const categoryId = Number(row.get('categoryId')?.value || 0);
      if (!categoryId) return;

      const category = this.categoryDetails.find(
        (c: any) => c.categoryId === categoryId
      );

      if (!category?.shippingList?.length) return;

      const totalQty = categoryQtyMap.get(categoryId) || 0; // ⭐ FIXED HERE

      category.shippingList.forEach((rule: any) => {

        if (!rule.isActive) return;

        if (
          rule.state?.trim().toLowerCase() !==
          zone.trim().toLowerCase()
        ) return;

        const start = Number(rule.productStartRange || 0);
        const end = Number(rule.productEndRange || 999999);

        // ⭐ FIXED: USE CATEGORY TOTAL QTY
        if (totalQty < start || totalQty > end) return;

        const partner = rule.shippingPartner;

        if (!partnerMap.has(partner)) {
          partnerMap.set(partner, {
            shippingPartner: partner,
            amount: 0,
            free: false,
            flatApplied: new Set<string>()
          });
        }

        const partnerData = partnerMap.get(partner)!;

        // ================= FREE SHIPPING =================
        if (
          rule.shippingType === 'FREE' ||
          Number(rule.shippingAmount) === 0
        ) {
          partnerData.free = true;
          partnerData.amount = 0;
          return;
        }

        if (partnerData.free) return;

        // ================= PER PRODUCT =================
        if (rule.rateType === 'PER_PRODUCT') {

          // ⭐ FIXED: CATEGORY TOTAL QTY
          partnerData.amount =
            Number(rule.shippingAmount) * totalQty;
        }

        // ================= FLAT RATE =================
        else if (rule.rateType === 'FLAT_RATE') {

          const key = categoryId + "_" + partner;

          if (!partnerData.flatApplied.has(key)) {
            partnerData.flatApplied.add(key);

            partnerData.amount = Number(rule.shippingAmount);
          }
        }

      });

    });

    // ================= RESULT =================
    this.shippingDetails = Array.from(partnerMap.values())
      .map(p => ({
        shippingPartner: p.shippingPartner,
        shippingType: p.free ? 'FREE' : 'PAID',
        amount: p.free ? 0 : p.amount
      }))
      .sort((a, b) => a.amount - b.amount);

    // ================= AUTO SELECT =================
    const apiShippingPartner =
      this.currentBillingDetails?.shippingPartner ||
      this.selectedShipping?.shippingPartner;

    if (this.shippingDetails.length > 0) {

      const matched = this.shippingDetails.find(
        x => x.shippingPartner === apiShippingPartner
      );

      if (matched) {

        // Keep the same partner selected
        this.selectedShipping = matched;

        // Update shipping amount according to the new quantity
        this.shipping = Number(matched.amount);

      } else {

        // Fallback to the cheapest partner
        this.selectedShipping = this.shippingDetails[0];
        this.shipping = Number(this.selectedShipping.amount);

      }

    } else {

      this.selectedShipping = null;
      this.shipping = 0;

    }

    this.updateTotalAmount();

  }

  selectShipping(ship: any) {

    this.selectedShipping = ship;

    this.shipping = ship.amount || 0;

    this.recalculateCart();

  }

  updateTotals() {

    this.grandTotal =
      this.productTotal
      - this.discountTotal
      + this.shipping;

  }

  public invoiceErrors = {
    phoneNumber: '',
    // customerName: '',
    products: '',
    resellerName: '',
    resellerPhone: '',
  }

  //on submit
  onSubmit() {
    this.invoiceValidation();
  }

  invoiceValidation(isDraft: boolean = false): void {

    let hasError = false;

    // Set current draft status
    this.isDraft = isDraft;

    // Clear previous errors
    this.invoiceErrors = {
      phoneNumber: '',
      // customerName: '',
      products: '',
      resellerName: '',
      resellerPhone: ''
    };

    // const customerNameCtrl =
    //   this.invoiceFormGroup.get('customerName');

    const phoneCtrl =
      this.invoiceFormGroup.get('phoneNumber');

    const productsArray =
      this.invoiceFormGroup.get('products') as UntypedFormArray;

    const resellerNameCtrl =
      this.invoiceFormGroup.get('resellerName');

    const resellerPhoneCtrl =
      this.invoiceFormGroup.get('resellerPhone');

    const billingType =
      this.invoiceFormGroup.get('billingType')?.value;

    const orderVia =
      this.invoiceFormGroup.get('orderVia')?.value;


    // ==========================================================
    // DRAFT
    // ==========================================================
    // Draft does not require complete invoice validation.
    // It only checks whether at least one product exists.
    // ==========================================================

    if (isDraft) {

      if (productsArray.length === 0) {

        this.invoiceErrors.products =
          'Add at least one product to save draft';

        this.toastr.error(
          this.invoiceErrors.products
        );

        return;
      }

      // Draft is allowed to continue
      this.saveOrUpdateInvoice(true);

      return;
    }


    // ==========================================================
    // NORMAL INVOICE - CUSTOMER VALIDATION
    // ==========================================================

    if (billingType === 'ONLINE') {

      // Customer Name
      // if (!customerNameCtrl?.value?.trim()) {

      //   this.invoiceErrors.customerName =
      //     'Customer Name is required';

      //   hasError = true;
      // }


      // Phone Number
      if (!phoneCtrl?.value) {

        this.invoiceErrors.phoneNumber =
          'Phone Number is required';

        hasError = true;

      } else if (
        !/^[6-9]\d{9}$/.test(
          String(phoneCtrl.value).trim()
        )
      ) {

        this.invoiceErrors.phoneNumber =
          'Enter a valid Indian mobile number (starts with 6-9)';

        hasError = true;
      }
    }


    // ==========================================================
    // RESELLER VALIDATION
    // ==========================================================

    if (orderVia === 'Resale') {

      // Reseller Name
      if (!resellerNameCtrl?.value?.trim()) {

        this.invoiceErrors.resellerName =
          'Reseller Name is required';

        hasError = true;
      }


      // Reseller Phone
      if (!resellerPhoneCtrl?.value) {

        this.invoiceErrors.resellerPhone =
          'Phone Number is required';

        hasError = true;

      } else if (
        !/^[6-9]\d{9}$/.test(
          String(resellerPhoneCtrl.value).trim()
        )
      ) {

        this.invoiceErrors.resellerPhone =
          'Enter a valid Indian mobile number (starts with 6-9)';

        hasError = true;
      }
    }


    // ==========================================================
    // PRODUCT EXISTENCE
    // ==========================================================

    if (productsArray.length === 0) {

      this.invoiceErrors.products =
        'Add at least one product to create a bill';

      this.toastr.error(
        this.invoiceErrors.products
      );

      hasError = true;
    }


    // ==========================================================
    // PRODUCT VALIDATION
    // ==========================================================

    if (productsArray.length > 0) {

      const invalidProduct =
        this.products.controls.find(
          (row: any) => {

            const productId =
              row.get('productId')?.value;

            const variantId =
              row.get('productVariantId')?.value;

            const name =
              row.get('productName')?.value;


            // ----------------------------------------------------
            // ONLINE
            // Variant / barcode is mandatory
            // ----------------------------------------------------

            if (billingType === 'ONLINE') {

              return !variantId;
            }


            // ----------------------------------------------------
            // SHOP
            // Manual product is allowed
            // ----------------------------------------------------

            if (billingType === 'SHOP') {

              return (
                !variantId &&
                (
                  !name ||
                  String(name).trim() === ''
                )
              );
            }


            return false;
          }
        );


      if (invalidProduct) {

        this.toastr.error(
          billingType === 'ONLINE'
            ? 'Please enter valid barcode before saving'
            : 'Please enter product name for manual item'
        );

        return;
      }
    }


    if (!hasError) {

  if (this.isUpdate) {

    if (
      this.invoiceFormGroup
        .get('billingStatus')
        ?.value === 'CANCELLED'
    ) {

      this.updatePopup();

    } else {

      // false = normal invoice update
      this.updateBillDetails(false);
    }

  } else {

    // false = normal invoice save
    this.saveInvoiceByAdmin(false);
  }
}

  }

  clearInvoiceErrors(): void {
    this.invoiceErrors = {
      phoneNumber: '',
      // customerName: '',
      products: '',
      resellerName: '',
      resellerPhone: ''
    };
  }

  cleanProductValues(): void {

    const productsArray =
      this.invoiceFormGroup.get('products') as UntypedFormArray;

    if (!productsArray) {
      return;
    }

    productsArray.controls.forEach((control: any) => {

      const productName =
        control.get('productName')?.value;

      const size =
        control.get('size')?.value;

      // Product name: "Product Name|123" -> "Product Name"
      if (productName) {
        control.get('productName')?.setValue(
          String(productName).split('|')[0]
        );
      }

      // Size: "XL|42" -> "XL"
      if (size) {
        control.get('size')?.setValue(
          String(size).split('|')[0]
        );
      }

    });
  }

  // ============================================================
  // COMMON SAVE / UPDATE
  // ============================================================

  saveOrUpdateInvoice(isDraft: boolean): void {

    // Set current status
    this.isDraft = isDraft;


    // ==========================================================
    // UPDATE
    // ==========================================================

    if (this.isUpdate) {

      const billingStatus =
        this.invoiceFormGroup
          .get('billingStatus')
          ?.value;


      if (billingStatus === 'CANCELLED') {

        this.updatePopup();

        return;
      }


      this.updateBillDetails(isDraft);

      return;
    }


    // ==========================================================
    // NEW SAVE
    // ==========================================================

    this.saveInvoiceByAdmin(isDraft);
  }



  // ============================================================
  // SAVE NEW INVOICE
  // ============================================================

  saveInvoiceByAdmin(isDraft: boolean = false): void {

  this.isDraft = isDraft;

  // ------------------------------------------
  // Draft
  // ------------------------------------------
  if (isDraft) {
    this.updateTotalAmount();
    this.updateWalletCalculation();
    this.saveInvoiceRequest(true);
    return;
  }

  // ------------------------------------------
  // Normal invoice
  // ------------------------------------------
  // Validation is already handled by
  // invoiceValidation()
  this.updateTotalAmount();
  this.updateWalletCalculation();

  this.saveInvoiceRequest(false);
}



private saveInvoiceRequest(isDraft: boolean): void {
  const payload: any = this.buildSavePayload(isDraft);

  // Read the selected order source from the form.
  const formValue = this.invoiceFormGroup.getRawValue();
  const orderVia = String(formValue.orderVia || '').trim();

  // Apply reseller details when Resale is selected.
  if (orderVia.toLowerCase() === 'resale') {
    const resellerName = String(
      formValue.resellerName || ''
    ).trim();

    const resellerPhone = String(
      formValue.resellerPhone || ''
    ).trim();

    if (!isDraft) {
      if (!resellerName) {
        this.toastr.error('Please enter reseller name');
        return;
      }

      if (!/^[6-9]\d{9}$/.test(resellerPhone)) {
        this.toastr.error(
          'Please enter a valid 10-digit reseller phone number'
        );
        return;
      }
    }

    payload.orderVia = 'Resale';
    payload.resellerName = resellerName;
    payload.resellerPhone = resellerPhone;

    // Use the buyerType value required by your backend.
    // Change this to 'USER' if your backend expects USER for Resale.
    payload.buyerType = 'RESELLER';
  } else {
    payload.orderVia = orderVia;
    payload.resellerName = '';
    payload.resellerPhone = '';

    // Preserve the existing buyerType when available.
    payload.buyerType =
      payload.buyerType ||
      formValue.buyerType ||
      'USER';
  }

  this.spinner.show();

  this.appService
    .saveInvoiceDetails(payload)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (response: any) => {
        this.spinner.hide();

        this.invoiceDetails = response;

        this.toastr.success(
          isDraft
            ? 'Draft saved successfully'
            : 'Invoice saved successfully'
        );

        const billId = response?.billId || 0;
        const buyerType =
          response?.buyerType || payload.buyerType;

        const encryptedBillId = CryptoJS.AES.encrypt(
          String(billId),
          this.secretKey
        ).toString();

        const encryptedBuyerType = CryptoJS.AES.encrypt(
          String(buyerType),
          this.secretKey
        ).toString();

        const encryptedScreenName = CryptoJS.AES.encrypt(
          'invoice',
          this.secretKey
        ).toString();

        this.router.navigate(['/bill'], {
          queryParams: {
            billId: encryptedBillId,
            buyerType: encryptedBuyerType,
            screenName: encryptedScreenName
          }
        });
      },

      error: (error: any) => {
        this.spinner.hide();

        this.toastr.error(
          error?.error?.message ||
          'Failed to save invoice'
        );
      }
    });
}


  // ============================================================
  // UPDATE INVOICE
  // ============================================================

  
updateBillDetails(isDraft: boolean = false): void {
  this.isDraft = isDraft;

  // 1. Recalculate invoice total
  this.updateTotalAmount();

  // 2. Recalculate wallet
  this.updateWalletCalculation();

  // 3. Read current form values
  const formValue = this.invoiceFormGroup.getRawValue();

  // 4. Build existing update payload
  const payload: any = this.buildUpdatePayload(isDraft);

  // 5. Apply Resale logic
  const orderVia = String(
    formValue.orderVia || payload.orderVia || ''
  ).trim();

  if (orderVia.toLowerCase() === 'resale') {
    const resellerName = String(
      formValue.resellerName || payload.resellerName || ''
    ).trim();

    const resellerPhone = String(
      formValue.resellerPhone || payload.resellerPhone || ''
    ).trim();

    // Validate Resale fields for a final invoice.
    // Drafts may be saved with incomplete details.
    if (!isDraft) {
      if (!resellerName) {
        this.toastr.error('Please enter reseller name');
        return;
      }

      if (!/^[6-9]\d{9}$/.test(resellerPhone)) {
        this.toastr.error(
          'Please enter a valid 10-digit reseller phone number'
        );
        return;
      }
    }

    payload.orderVia = 'Resale';
    payload.resellerName = resellerName;
    payload.resellerPhone = resellerPhone;

    // Confirm that your backend accepts RESELLER.
    // If it expects USER, replace RESELLER with USER.
    payload.buyerType = 'RESELLER';
  } else {
    payload.orderVia = orderVia;
    payload.resellerName = '';
    payload.resellerPhone = '';

    payload.buyerType =
      payload.buyerType ||
      formValue.buyerType ||
      'USER';
  }

  // 7. Validate bill ID
  if (!payload.billId) {
    this.toastr.error('Bill ID is missing');
    return;
  }

  // 8. Call update API
  this.spinner.show();

  this.appService
    .updateBillDetails(payload)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (response: any) => {
        this.spinner.hide();

        this.toastr.success(
          isDraft
            ? 'Draft updated successfully'
            : 'Invoice updated successfully'
        );

        // 9. Navigate to the updated bill
        const billId = response?.billId || payload.billId;
        const buyerType = response?.buyerType || payload.buyerType;

        const encryptedBillId = CryptoJS.AES.encrypt(
          String(billId),
          this.secretKey
        ).toString();

        const encryptedBuyerType = CryptoJS.AES.encrypt(
          String(buyerType),
          this.secretKey
        ).toString();

        const encryptedScreenName = CryptoJS.AES.encrypt(
          'invoice',
          this.secretKey
        ).toString();

        this.router.navigate(['/bill'], {
          queryParams: {
            billId: encryptedBillId,
            buyerType: encryptedBuyerType,
            screenName: encryptedScreenName
          }
        });
      },

      error: (error: any) => {
        this.spinner.hide();

        this.toastr.error(
          error?.error?.message ||
          'Failed to update invoice'
        );
      }
    });
}


  //get all reseller details
  getAllResellers() {
    this.spinner.show();
    this.appService.getAllResellerDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resellerDetails :any) => {
        this.spinner.hide();
        this.resellerList = resellerDetails;
      }, (error: any) => {
        this.spinner.hide();
        if (error && error.error && error.error.message) {
          this.spinner.hide();
          this.toastr.error(error.error.message);
        } else {
          this.spinner.hide();
          this.toastr.error("Something went wrong, please try again");
        }
      })
  }

  onResellerSelect(event: any): void {
    const selectedAddressId = parseInt(event.target.value, 10);
    const selectedReseller = this.resellerList.find(reseller => reseller.addressId === selectedAddressId);

    if (selectedReseller) {
      this.invoiceFormGroup.get('reSellerAddress')?.patchValue({
        addressId: selectedReseller.addressId,
        name: selectedReseller.name,
        phoneNumber: selectedReseller.phoneNumber,
        doorNo: selectedReseller.doorNo,
        streetName: selectedReseller.streetName,
        city: selectedReseller.city,
        state: selectedReseller.state,
        pinCode: selectedReseller.pinCode
      });
    } else {
      this.invoiceFormGroup.get('reSellerAddress')?.patchValue({
        addressId: 0,
        name: '',
        phoneNumber: '',
        doorNo: '',
        streetName: '',
        city: '',
        state: 'Tamil Nadu',
        pinCode: ''
      });
    }
  }

  updatePopup() {
    Swal.fire({
      title: "This bill has been canceled. Do you want to update its details?",
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateBillDetails();
      }
    });
  }

 private buildSavePayload(isDraft: boolean): any {

  const formValue = this.invoiceFormGroup.getRawValue();

  const products = (formValue.products || []).map((item: any) => ({
    productVariantId: Number(item.productVariantId || 0),
    productName: item.productName
      ? String(item.productName).split('|')[0].trim()
      : '',
    quantity: Number(item.quantity || 0),
    unitPrice: Number(item.unitPrice || 0)
  }));

  // Get address ID
  const addressId = Number(
    this.selectedCustomerAddress?.addressId ||
    formValue.addressId ||
    0
  );

  // Existing address -> bulkAddress empty
  // New address -> bulkAddress from userAddress
  const bulkAddress = addressId !== 0
    ? ''
    : String(formValue.userAddress || '').trim();

  const userAddresses = this.selectedCustomerAddress
    ? [{
        ...this.selectedCustomerAddress,
        buyerType: this.selectedCustomerAddress.buyerType || 'USER'
      }]
    : (formValue.userAddresses || []);

  return {

    buyerType:
      formValue.buyerType || 'USER',

    billingType:
      formValue.billingType || 'ECOMMERCE',

    paidAmount:
      Number(formValue.paidAmount || 0),

    paymentMethod:
      formValue.paymentMethod || 'CASH',

    transactionRefId:
      formValue.transactionRefId || '',

    shippingAmount:
      Number(this.shipping || formValue.shippingAmount || 0),

    shippingPartner:
      this.selectedShipping?.shippingPartner ||
      formValue.shippingPartner ||
      '',

    weight:
      Number(formValue.weight || 0),

    trackingNumber:
      formValue.trackingNumber || '',

    orderVia:
      formValue.orderVia || '',

    userAddress:
      formValue.userAddress || '',

    discount:
      Number(this.discountTotal || formValue.discount || 0),

    manualDiscountAmount:
      Number(formValue.manualDiscountAmount || 0),

    customerName:
      formValue.customerName || '',

    phoneNumber:
      formValue.phoneNumber || '',

    shopAddressId:
      Number(formValue.shopAddressId || 0),

    resellerName:
      formValue.resellerName || '',

    resellerPhone:
      formValue.resellerPhone || '',

    gstNumber:
      formValue.gstNumber || '',

    state: formValue.state || "Tamil Nadu",

    // Existing address ID
    addressId: addressId,

    userAddresses:
      userAddresses,

    // IMPORTANT
    // addressId != 0 => ""
    // addressId == 0 => userAddress
    bulkAddress:
      bulkAddress,

    products:
      products,

    walletDebitAmount:
      Number(this.walletDebitAmount || 0),

    billingStatus:
      isDraft
        ? 'PENDING'
        : (
            Number(formValue.dueAmount || 0) <= 0
              ? 'PAID'
              : 'PENDING'
          ),

    walletCreditAmount:
      Number(this.walletCreditAmount || 0),

    isDraft:
      isDraft,

    isReduceFromWallet:
      Boolean(this.isReduceFromWallet)
  };
}


private buildUpdatePayload(isDraft: boolean): any {
  const formValue = this.invoiceFormGroup.getRawValue();

  // ==========================================================
  // PRODUCTS
  // ==========================================================
  const products = (formValue.products || []).map((item: any) => {
    const quantity = Number(item.quantity || 0);
    const unitPrice = Number(item.unitPrice || 0);

    return {
      billingItemId: Number(item.billingItemId || 0),
      productId: Number(item.productId || 0),
      productVariantId: Number(item.productVariantId || 0),

      productCode: item.productCode || item.barcodeNumber || '',

      productName: item.productName
        ? String(item.productName).split('|')[0].trim()
        : '',

      size: item.size
        ? String(item.size).split('|')[0].trim()
        : '',

      hsnCode: item.hsnCode || '',
      quantity: quantity,

      totalPrice: Number(
        item.totalPrice || quantity * unitPrice
      ),

      unitPrice: unitPrice,
      createdAt: Number(item.createdAt || 0),
      updatedAt: Date.now(),

      basePrice: Number(item.basePrice || unitPrice),
      discountAmount: Number(item.discountAmount || 0),

      discountedPrice: Number(
        item.discountedPrice ||
        item.totalPrice ||
        quantity * unitPrice
      ),

      gstAmount: Number(item.gstAmount || 0),
      cgstAmount: Number(item.cgstAmount || 0),
      sgstAmount: Number(item.sgstAmount || 0),
      igstAmount: Number(item.igstAmount || 0),

      priceWithGst: Number(
        item.priceWithGst ||
        item.totalPrice ||
        quantity * unitPrice
      ),

      priceWithoutGst: Number(
        item.priceWithoutGst ||
        item.totalPrice ||
        quantity * unitPrice
      )
    };
  });

  // ==========================================================
  // ADDRESS
  // ==========================================================
  const address =
    this.selectedCustomerAddress ||
    formValue.userAddresses?.[0] ||
    {};

  // Get the selected address ID.
  // Fall back to form values if the selected address ID is 0.
  const deliveryAddressId = Number(
    address.addressId ||
    formValue.deliveryAddressId ||
    formValue.addressId ||
    0
  );

  // Existing address ID: send empty bulkAddress.
  // New/manual address (ID 0): send the manually entered address.
  const bulkAddress =
    deliveryAddressId === 0
      ? String(formValue.userAddress || '').trim()
      : '';

  // ==========================================================
  // TOTALS
  // ==========================================================
  const totalAmount = Number(formValue.totalAmount || 0);
  const subTotal = Number(formValue.subTotal || 0);

  const discount = Number(
    this.discountTotal ||
    formValue.discount ||
    0
  );

  const manualDiscountAmount = Number(
    formValue.manualDiscountAmount || 0
  );

  const shippingAmount = Number(
    this.shipping ||
    formValue.shippingAmount ||
    0
  );

  const paidAmount = Number(formValue.paidAmount || 0);

  const dueAmount = Math.max(
    Number(formValue.dueAmount || 0),
    0
  );

  // ==========================================================
  // GST
  // ==========================================================
  const gstValue = Number(formValue.gstValue || 0);
  const cgstValue = Number(formValue.cgstValue || 0);
  const sgstValue = Number(formValue.sgstValue || 0);
  const igstValue = Number(formValue.igstValue || 0);
  const withGst = Number(formValue.withGst || 0);
  const withoutGst = Number(formValue.withoutGst || 0);

  const taxableAmount = Number(
    formValue.taxableAmount ||
    withoutGst ||
    0
  );

  const totalGstAmount = Number(
    formValue.totalGstAmount ||
    gstValue ||
    (cgstValue + sgstValue + igstValue)
  );

  // ==========================================================
  // BILLING STATUS
  // ==========================================================
  let billingStatus = formValue.billingStatus || 'PENDING';

  if (!isDraft) {
    if (dueAmount <= 0) {
      billingStatus = 'PAID';
    } else if (paidAmount > 0) {
      billingStatus = 'PARTIALLY_PAID';
    } else {
      billingStatus = 'PENDING';
    }
  } else {
    billingStatus = 'PENDING';
  }

  // ==========================================================
  // TRANSACTION
  // ==========================================================
  const transactionDetails = {
    transactionId: Number(
      formValue.transactionDetails?.transactionId || 0
    ),

    transactionRefId:
      formValue.transactionDetails?.transactionRefId ||
      formValue.transactionRefId ||
      '',

    paymentId:
      formValue.transactionDetails?.paymentId || '',

    paymentMethod:
      formValue.transactionDetails?.paymentMethod ||
      formValue.paymentMethod ||
      'CASH',

    orderType:
      formValue.transactionDetails?.orderType ||
      formValue.orderType ||
      'COD',

    amount: Number(
      formValue.transactionDetails?.amount ||
      paidAmount ||
      0
    ),

    paymentStatus:
      formValue.transactionDetails?.paymentStatus ||
      'INITIATED',

    createdAt: Number(
      formValue.transactionDetails?.createdAt || 0
    ),

    updatedAt: Date.now()
  };

  // ==========================================================
  // UPDATE PAYLOAD
  // ==========================================================
  return {
    // BILL ID
    billId: Number(
      formValue.billId ||
      this.billId ||
      0
    ),

    // CUSTOMER
    customerName: formValue.customerName || '',
    phoneNumber: formValue.phoneNumber || '',
    gstNumber: formValue.gstNumber || '',
    resellerName: formValue.resellerName || '',
    resellerPhone: formValue.resellerPhone || '',

    // BILL DETAILS
    billMonth: formValue.billMonth || '',
    transactionRefId: formValue.transactionRefId || '',

    // ADDRESS
    doorNo: address.doorNo || formValue.doorNo || '',

street:
  address.streetName ||
  address.street ||
  formValue.street ||
  '',

city: address.city || formValue.city || '',

state: address.state || formValue.state || 'Tamil Nadu',

pincode:
  address.pinCode ||
  address.pincode ||
  formValue.pincode ||
  '',

deliveryAddressId: deliveryAddressId,

// Existing address ID: empty bulkAddress.
// New/manual address: use the entered address.
bulkAddress: bulkAddress,

userAddress: formValue.userAddress || '',

    // SHOP
    shopId: Number(formValue.shopId || 0),

    // BILL TYPE
    billType:
      formValue.billType ||
      (formValue.billingType === 'SHOP' ? 'SHOP' : 'ONLINE'),

    // TOTALS
    totalAmount: totalAmount,
    discount: discount,
    manualDiscountAmount: manualDiscountAmount,
    subTotal: subTotal,

    shippingCharge: shippingAmount,

    actualShippingAmount: Number(
      formValue.actualShippingAmount ||
      shippingAmount ||
      0
    ),

    // STATUS
    billingStatus: billingStatus,

    adminStatus:
      formValue.adminStatus ||
      'NOT_APPROVED',

    // PAYMENT
    paymentMethod:
      formValue.paymentMethod ||
      'CASH',

    billingType:
      formValue.billingType ||
      'ECOMMERCE',

    buyerType:
      formValue.buyerType ||
      'USER',

    orderType:
      formValue.orderType ||
      'COD',

    // SHIPPING
    shippingAmount: shippingAmount,

    invoiceDate: formValue.invoiceDate || '',
    orderId: formValue.orderId || '',

    shippingPartner:
      this.selectedShipping?.shippingPartner ||
      formValue.shippingPartner ||
      '',

    orderVia: formValue.orderVia || '',
    weight: formValue.weight || '',
    trackingNumber: formValue.trackingNumber || '',

    // EXISTING BILL INFORMATION
    createdAt: Number(formValue.createdAt || 0),
    createdBy: Number(formValue.createdBy || 0),
    updatedAt: Date.now(),
    updatedBy: Number(formValue.updatedBy || 0),

    userRegId: Number(
      formValue.userRegId ||
      this.customerDetails?.userRegistrationId ||
      0
    ),

    invoiceNumber: formValue.invoiceNumber || '',
    exchangeStatus: formValue.exchangeStatus || '',

    // PRODUCTS
    products: products,

    // OTHER AMOUNTS
    exchangeAmount: Number(formValue.exchangeAmount || 0),
    note: formValue.note || '',

    // // Keep the address available for invoice display.
    // userAddress: formValue.userAddress || '',

    // PAYMENT AMOUNTS
    paidAmount: paidAmount,
    dueAmount: dueAmount,

    // TRANSACTION
    transactionDetails: transactionDetails,

    // GST
    gstValue: gstValue,
    cgstValue: cgstValue,
    sgstValue: sgstValue,
    igstValue: igstValue,
    withGst: withGst,
    withoutGst: withoutGst,

    // SHOP ADDRESS
    shopAddressId: Number(formValue.shopAddressId || 0),
    shopAddress: formValue.shopAddress || null,

    // ORDER
    orderStatus: formValue.orderStatus || '',

    // WALLET
    walletCreditAmount: Number(
      this.walletCreditAmount || 0
    ),

    walletDebitAmount: Number(
      this.walletDebitAmount || 0
    ),

    // CALCULATED AMOUNTS
    baseAmount: Number(
      formValue.baseAmount ||
      subTotal ||
      0
    ),

    totalDiscountAmount: Number(
      formValue.totalDiscountAmount ||
      (discount + manualDiscountAmount)
    ),

    taxableAmount: taxableAmount,
    totalGstAmount: totalGstAmount,

    // DRAFT / WALLET
    isDraft: isDraft,

    isReduceFromWallet: Boolean(
      this.isReduceFromWallet
    )
  };
}



private isResaleOrder(): boolean {
  return (
    this.invoiceFormGroup.get('orderVia')?.value === 'Resale'
  );
}

private getResellerPayload(formValue: any): any {
  const isResale = this.isResaleOrder();

  return {
    buyerType: isResale ? 'RESELLER' : 'USER',
    orderVia: formValue.orderVia || '',

    resellerName: isResale
      ? String(formValue.resellerName || '').trim()
      : '',

    resellerPhone: isResale
      ? String(formValue.resellerPhone || '').trim()
      : ''
  };
}

private validateReseller(): boolean {
  if (!this.isResaleOrder()) {
    return true;
  }

  const resellerName = String(
    this.invoiceFormGroup.get('resellerName')?.value || ''
  ).trim();

  const resellerPhone = String(
    this.invoiceFormGroup.get('resellerPhone')?.value || ''
  ).trim();

  if (!resellerName) {
    this.invoiceErrors.resellerName =
      'Please enter reseller name';
    return false;
  }

  if (!/^[6-9]\d{9}$/.test(resellerPhone)) {
    this.invoiceErrors.resellerPhone =
      'Please enter a valid 10-digit reseller phone number';
    return false;
  }

  this.invoiceErrors.resellerName = '';
  this.invoiceErrors.resellerPhone = '';

  return true;
}


  clearRow(row: UntypedFormGroup) {

    const barcode = row.get('barcodeNumber')?.value;

    row.patchValue({
      productId: 0,
      productVariantId: 0,
      productName: '',
      size: '',
      productCode: barcode,
      categoryId: 0,

      quantity: 1,
      unitPrice: 0,
      totalPrice: 0,

      discount: 0,
      discounts: [],

      // ✅ ONLY RESET IF EMPTY
      availableStock: barcode ? row.get('availableStock')?.value : 0,
      oldQuantity: 0

    }, { emitEvent: false });

    this.afterRowUpdate();
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    localStorage.removeItem('billId');
  }
}
